
import React from 'react';
import { RentalInfo } from '@/hooks/types/rentalTypes';
import { TariffSelectionDialog } from './TariffSelectionDialog';
import { FullScreenTariffSelection } from '@/pages/courier/FullScreenTariffSelection';
import { ActiveRentalTariffCard } from './tariff/ActiveRentalTariffCard';
import { NoRentalTariffCard } from './tariff/NoRentalTariffCard';
import { TariffInfoLoading } from './tariff/TariffInfoLoading';
import { TariffInfoError } from './tariff/TariffInfoError';
import { useTariffInfo } from './tariff/useTariffInfo';

interface TariffInfoCardProps {
  rental: RentalInfo | null;
  loading: boolean;
}

export function TariffInfoCard({ rental, loading }: TariffInfoCardProps) {
  const {
    isLoading,
    error,
    currentTariff,
    amoCustomerCode,
    amoDealCode,
    clientNumber,
    showTariffSelection,
    setShowTariffSelection,
    showFullscreenTariff,
    setShowFullscreenTariff,
    handleOpenFullscreenTariff,
    handleOpenTariffDialog
  } = useTariffInfo();

  if (loading || isLoading) {
    return <TariffInfoLoading />;
  }

  if (error) {
    return <TariffInfoError error={error} />;
  }

  // Если нет аренды, показываем возможность выбора тарифа
  if (!rental || !rental.id) {
    return (
      <>
        <NoRentalTariffCard 
          currentTariff={currentTariff} 
          onSelectTariff={() => {
            console.log('Выбор тарифа запрошен через NoRentalTariffCard');
            handleOpenFullscreenTariff();
          }}
        />
        
        {/* Диалоги для выбора тарифа */}
        {renderTariffDialogs()}
      </>
    );
  }

  return (
    <>
      <ActiveRentalTariffCard 
        rental={rental} 
        currentTariff={currentTariff}
        onSelectOtherTariffs={() => {
          console.log('Выбор других тарифов запрошен через ActiveRentalTariffCard');
          handleOpenFullscreenTariff();
        }}
        onExtendTariff={handleOpenFullscreenTariff}
      />
      
      {/* Диалоги для выбора тарифа */}
      {renderTariffDialogs()}
    </>
  );

  function renderTariffDialogs() {
    return (
      <>
        <TariffSelectionDialog
          open={showTariffSelection}
          onOpenChange={setShowTariffSelection}
          amoCustomerCode={amoCustomerCode}
          amoDealCode={amoDealCode}
          clientNumber={clientNumber}
        />
        
        {showFullscreenTariff && (
          <FullScreenTariffSelection
            onBack={() => setShowFullscreenTariff(false)}
            amoCustomerCode={amoCustomerCode}
            amoDealCode={amoDealCode}
            clientNumber={clientNumber}
          />
        )}
      </>
    );
  }
}
